import { Modal } from "bootstrap";

import {
    forwardRef,
    useImperativeHandle,
    useRef,
    useState,
} from "react";

import Select from "react-select";

import {
    useForm,
    Controller,
} from "react-hook-form";

import { toast } from "react-toastify";

// import * as b2cleadService from "../../Services/b2cleadService";
import * as b2bleadService from "../../Services/b2bleadService";

const B2BStageModal = forwardRef(
    (props, ref) => {

        const {
            selectedLeads,
            getLeadData,
            setSelectedLeads,
        } = props;

        const {
            control,
            handleSubmit,
            reset,
            formState: { errors },
        } = useForm({
            mode: "onSubmit",
        });

        const modalRef = useRef(null);

        const bsModal = useRef(null);

        // STATES
        const [stageOptions, setStageOptions] =
            useState([]);

        const [submitLoader, setSubmitLoader] =
            useState(false);
        const leadIdRef = useRef(null);
        const stageRef = useRef("");

        // RESET + CLOSE
        const handleClose = () => {

            reset();

            bsModal.current?.hide();

        };

        // MODAL HANDLE
        useImperativeHandle(ref, () => ({

            toggle(leadId,stage) {

                leadIdRef.current = leadId;
                 stageRef.current = stage;

                if (!bsModal.current) {

                    bsModal.current =
                        new Modal(
                            modalRef.current
                        );

                }

                bsModal.current.show();

                getStageOptions();

            },

            close() {

                handleClose();

            },

        }));

        // GET STAGE OPTIONS
        const getStageOptions = () => {

            b2bleadService

                .getLeadStageMasterData(8)

                .then((res) => {

                    if (
                        res?.data?.status ===
                        "success"
                    ) {

                        const options =
                            res?.data?.data?.map(
                                (item) => ({

                                    label:
                                        item?.name,

                                    value:
                                        item?.name,

                                })
                            );

                        setStageOptions(
                            options
                        );

                    }

                })

                .catch((err) => {

                    console.log(
                        "STAGE ERROR",
                        err
                    );

                });

        };

        // SUBMIT
        const onSubmit = async (data) => {

            setSubmitLoader(true);

            const leadId = leadIdRef.current;

            try {

                const formData = new FormData();

                formData.append(
                    "status",
                    data?.stage?.value
                );

                const res =
                    await b2bleadService.leadstage(
                        leadId,
                        formData
                    );

                if (
                    res?.data?.status ===
                    "success"
                ) {

                    toast.success(
                        "Stage Updated Successfully"
                    );

                    handleClose();

                    getLeadData();

                }

            } catch (err) {

                console.log(
                    "UPDATE ERROR",
                    err
                );

                toast.error(
                    "Failed To Update Stage"
                );

            } finally {

                setSubmitLoader(false);

            }

        };

        return (

            <div
                className="modal fade"
                ref={modalRef}
                tabIndex="-1"
                aria-hidden="true"
                style={{
                    background:
                        "rgba(15,23,42,0.55)",

                    backdropFilter:
                        "blur(5px)",
                }}
            >

                <div className="modal-dialog modal-lg modal-dialog-centered">

                    <div className="modal-content border-0 rounded-4 ">

                        {/* HEADER */}
                        <div
                            className="modal-header border-0 text-white"
                            style={{
                                background:
                                    "rgb(94, 44, 158)",
                            }}
                        >

                            <div>
                                {/* 
                                <h4 className="modal-title fw-bold text-dark mb-1">

                                    Bulk Stage

                                </h4> */}

                                <p className="mb-0 small opacity-75">

                                    Update stage for lead

                                    {stageRef.current &&
                                        ` - ${stageRef.current}`}

                                </p>

                            </div>

                            <button
                                type="button"
                                className="btn btn-light rounded-circle position-absolute"
                                style={{
                                    top: "10px",
                                    right: "18px",
                                    width: "38px",
                                    height: "38px",
                                }}
                                onClick={
                                    handleClose
                                }
                            >

                                <i className="fa fa-times"></i>

                            </button>

                        </div>

                        {/* FORM */}
                        <form
                            onSubmit={handleSubmit(
                                onSubmit
                            )}
                        >

                            {/* BODY */}
                            <div className="modal-body p-4">

                                <div className="row g-4">

                                    {/* STAGE */}
                                    <div className="col-md-12">

                                        <label className="form-label fw-semibold">

                                            Select Stage

                                            <span className="text-danger ms-1">
                                                *
                                            </span>

                                        </label>

                                        <Controller
                                            name="stage"
                                            control={
                                                control
                                            }
                                            rules={{
                                                required:
                                                    "Please select atleast one stage",
                                            }}
                                            render={({
                                                field,
                                            }) => (

                                                <Select
                                                    {...field}
                                                    placeholder="Select Stage"
                                                    options={
                                                        stageOptions
                                                    }
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    value={
                                                        field.value || null
                                                    }
                                                    isClearable
                                                    isSearchable
                                                />

                                            )}
                                        />

                                        {errors.stage && (

                                            <small className="text-danger fw-semibold">

                                                {
                                                    errors
                                                        .stage
                                                        .message
                                                }

                                            </small>

                                        )}

                                    </div>

                                </div>

                            </div>

                            {/* FOOTER */}
                            <div className="modal-footer border-0 px-4 pb-4">

                                <button
                                    type="button"
                                    className="btn btn-sm btn-light border rounded-pill px-4 fw-semibold"
                                    onClick={
                                        handleClose
                                    }
                                >

                                    Close

                                </button>

                                <button
                                    type="submit"
                                    className="btn btn-sm btn-primary rounded-pill px-4 fw-semibold shadow-sm"
                                    disabled={
                                        submitLoader
                                    }
                                >

                                    {submitLoader
                                        ? "Updating..."
                                        : "Save"}

                                </button>

                            </div>

                        </form>

                    </div>

                </div>

            </div>

        );

    }
);

export default B2BStageModal;